export type Ga4Data = any

declare const window: {
  dataLayer?: {push: (data: Ga4Data) => void}
}

export const ga4 = (data: Ga4Data) => {
  if (!window.dataLayer) {
    return
  }

  window.dataLayer.push(data)
}
